import { createFileRoute } from '@tanstack/react-router'
import { KepribadianAI } from '../../../../components/KepribadianAI'

export const Route = createFileRoute('/platform/desa/$desaId/kepribadian-ai')({
  component: () => {
    const { desaId } = Route.useParams()
    return <KepribadianAI desaId={desaId} />
  },
})
